var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg824",
    width: 33,
    height: 30,
    viewBox: "0 0 33.279998779296875 30.079999923706055",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 33.279998779296875,
    height: 30.079999923706055,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.018919,8.1174856 1.8109427,28.236158 H 31.448906 L 27.21544,21.71832 m -3.25127,-5.054152 -2.32704,-3.800577",
    stroke: "#000000",
    strokeWidth: 4.11788,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path948-5",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3.62217,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.739124,4.5318516 c 0,2.5028176 -2.031752,4.531852 -4.537923,4.531852 -2.50617,0 -4.537924,-2.0290344 -4.537924,-4.531852 C 11.663277,2.029034 13.695031,0 16.201201,0 c 2.506171,0 4.537923,2.029034 4.537923,4.5318516 z m -5.871798,0 c 0,0.7356699 0.59722,1.3320893 1.333875,1.3320893 0.736657,0 1.333874,-0.5964194 1.333874,-1.3320893 0,-0.7356713 -0.597217,-1.3320892 -1.333874,-1.3320892 -0.736655,0 -1.333875,0.5964179 -1.333875,1.3320892 z",
    fill: "#0f2426",
    id: "path950-4",
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.137421
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.219,6.200326v23.5924",
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 3
    },
    id: "e2_pathV"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/ia.719ae52c1d97cbfd5d27d08bc5cc1e06.svg";
export { ForwardRef as ReactComponent };